// Each includes a real fallback stack -- if the self-hosted woff2 ever
// fails to load, the browser should land on a plain sans-serif, not its
// serif default (that gap is exactly what made the page render as Times
// New Roman in production once before: a CSP blocked the old Google Fonts
// <link>, and with no fallback listed there was nothing to catch it).
export const FONT_DISPLAY = "font-['Archivo_Narrow',sans-serif]";
export const FONT_BODY = "font-['IBM_Plex_Sans',sans-serif]";
// Reserved for anonymous connection codes and other data-like values, not
// running text -- a monospace face makes fixed-width codes like DM-4829
// visually distinct from prose at a glance.
export const FONT_MONO = "font-['IBM_Plex_Mono',monospace]";

// One rhythm for every landing-page section (owner 2026-10-02: sections
// looked like they came from different websites). Same side padding, same
// vertical spacing, same content width, same eyebrow and heading.
export const SECTION_PAD = 'w-full px-5 py-12 sm:px-6 lg:px-20 lg:py-14';
export const CONTAINER = 'mx-auto w-full max-w-[1280px]';
export const EYEBROW =
  'text-[12px] font-bold tracking-wider text-accent uppercase';
export const SECTION_H2 = `${FONT_DISPLAY} text-[32px] leading-[1.05] font-bold text-ink lg:text-[44px]`;
